<script setup lang="ts">
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
})

/**
 *
 * @param date is string which come from backend
 * @returns string
 */
const formatDate = (date: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }

  const formattedDate = new Date(date).toLocaleDateString('en-US', options)
  return formattedDate
}
</script>
<template>
  <div class="relative">
    <img class="w-full" :src="props.blog.attributes.banner.data.attributes.url" alt="banner" />
    <div
      class="absolute bottom-0 flex h-full w-full flex-col items-start justify-center bg-gradient-to-b from-transparent to-black/50 pl-5 md:pl-20"
    >
      <h1
        class="w-2/3 text-base font-bold leading-tight text-white sm:w-1/2 sm:text-[24px] xl:text-[48px]"
      >
        {{ props.blog.attributes.title }}
      </h1>
      <div
        class="blured-transparent-bg mt-1 flex items-center rounded-lg px-2 py-2 text-xs text-white sm:mt-6 sm:py-4 sm:text-base md:mt-2.5 md:px-3"
      >
        {{ props.blog.attributes.readMinutes }} min read
        <span class="mx-2 block h-2 w-2 rounded-full bg-text-brand md:mx-4"></span> Published Date:
        {{ formatDate(props.blog.attributes.publishedAt) }}
      </div>
    </div>
  </div>
</template>
<style>
.blured-transparent-bg {
  background: rgba(232, 233, 237, 0.1);
  backdrop-filter: blur(75px);
}
</style>
